<template>
  <div id="app">
    <div v-if="ready" class="page-wrapper" v-bind:class="{'page-wrapper--front' : isFront}">
      <router-view></router-view>
      <prev-next-nav v-if="!isFront"></prev-next-nav>
    </div>
    <menu-bar v-if="ready && !isFront"></menu-bar>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Hammer from 'hammerjs';
import MenuBar from '@/components/MenuBar';
import PrevNextNav from '@/components/PrevNextNav';

function isClassInParents(element, className) {
  if (element.classList.contains(className)) {
    return true;
  }

  return element.parentNode && element.nodeName !== 'BODY' && isClassInParents(element.parentNode, className);
}


export default {
  components: { MenuBar, PrevNextNav },
  name: 'app',
  data() {
    return {
      prevID: false,
    };
  },
  methods: {
    ...mapActions(['getProducts']),
  },
  mounted() {
    const hammertime = new Hammer(this.$el);
    hammertime.on('swipeleft', (ev) => {
      if (!isClassInParents(ev.target, 'no-swipe-nav')) {
        this.$router.push(this.nextPageRouterArray);
      }
    });
    hammertime.on('swiperight', (ev) => {
      // if (ev.target.localName !== 'canvas') {
      if (!isClassInParents(ev.target, 'no-swipe-nav')) {
        this.$router.push(this.prevPageRouterArray);
      }
    });
  },
  beforeMount() {
    this.getProducts();
  },
  computed: {
    ...mapGetters(['ready', 'isFront', 'nextPageRouterArray', 'prevPageRouterArray']),
  },
  watch: {
    $route() {
      if (this.prevID !== this.$route.params.id) {
        window.scrollTo(0, 0);
      }
      this.prevID = this.$route.params.id;
    },
  },
};
</script>

<style lang="scss">
@import './scss/helpers';
@import './scss/core';

html, body {
  background: #ffffff;
  margin: 0;
  padding: 0;
  min-height: 100%;
  width: 100%;
}

#app {
  font-family: $t_font;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  position: absolute;
  color: $c_black--broken;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .font-alternative & {
    font-family: $t_font-alternative;
  }

  .font-chinese & {
    font-family: $t_font-chinese;
  }

  .font-japanese & {
    font-family: $t_font-japanese;
  }
}


.page-wrapper {
  display: block;
  padding-bottom: 70px;

  &--front {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue